import {EtudiantInscrit} from '../etudiantInscrit/etudiantInscrit.model';
import {Principal} from '..';

export class User {

    public id?: any;
    public login?: string;
    public civilite?: string;
    public firstName?: string;
    public otherNames?: string;
    public lastName?: string;
    public lastNameUsage?: string;
    public birthDate?: Date;
    public email?: string;
    public activated?: Boolean;
    public pluriannuel?: Boolean;
    public langKey?: string;
    public authorities?: any[];
    public createdBy?: string;
    public createdDate?: Date;
    public lastModifiedBy?: string;
    public lastModifiedDate?: Date;
    public password?: string;
    public etudiant?: EtudiantInscrit;

    // un utilisateur peut candidater :
    //   - si il est déjà étudiant à L'ENS
    //   - si il n'a pas un mail ENS et qu'il a un role USER
    public static userPeutCandidater(user: User): Boolean {
        let peutCandidater = false;
        if (user != null) {
            if (user.etudiant != null && user.etudiant.numeroEtudiant != null) {
                peutCandidater = true;
            } else {
                if (!user.email.endsWith('@ens-lyon.fr')) {
                    if (Principal.isAuthorityInListe('ROLE_USER', user.authorities)) {
                        peutCandidater = true;
                    }
                }
            }
        }
        return peutCandidater ;
    }

    // un utilisateur est en resincription si  :
    //   - si il est déjà étudiant à L'ENS
    public static userResinscription(user: User): Boolean {
        let reinscription = false;
        if (user != null) {
            if (user.etudiant != null && user.etudiant.numeroEtudiant != null) {
                reinscription = true;
            }
        }
        return reinscription ;
    }

    constructor(
        id?: any,
        login?: string,
        civilite?: string,
        firstName?: string,
        otherNames?: string,
        lastName?: string,
        lastNameUsage?: string,
        birthDate?: Date,
        email?: string,
        activated?: Boolean,
        pluriannuel?: Boolean,
        langKey?: string,
        authorities?: any[],
        createdBy?: string,
        createdDate?: Date,
        lastModifiedBy?: string,
        lastModifiedDate?: Date,
        password?: string
    ) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.civilite = civilite ? civilite : null;
        this.firstName = firstName ? firstName : null;
        this.otherNames = otherNames ? otherNames : null;
        this.lastName = lastName ? lastName : null;
        this.lastNameUsage = lastNameUsage ? lastNameUsage : null;
        this.birthDate = birthDate ? birthDate : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.pluriannuel = pluriannuel ? pluriannuel : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/user/user.model.ts